import { NgModule } from '@angular/core';

import { FileReaderService } from './file-reader.service';
import { ImageReaderService } from './image-reader.service';

@NgModule({
    providers: [FileReaderService, ImageReaderService]
})
export class FileReaderModule {}
